import React, { createContext, useState, useEffect, useContext, useMemo } from "react";
import { API_HOST } from "./constant";
import SetInterceptors from "../api/axiosInterceptors";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({ name: "user", roles_id: 0 });
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [role, setRole] = useState(localStorage.getItem("role"));
    const [loading, setLoading] = useState(!!localStorage.getItem("token"));

    // Derived state to replace local variables in App.js
    const isLogged = useMemo(() => {
        return !!(token && user.name !== "user" && role);
    }, [token, user, role]);

    const isAdmin = useMemo(() => token && Number(role) === 1, [token, role]);
    const isUser = useMemo(() => token && Number(role) === 2, [token, role]);
    const isAccountant = useMemo(() => token && Number(role) === 3, [token, role]);
    const isSeller = useMemo(() => token && Number(role) === 4, [token, role]);

    const getUser = async (jwt) => {
        try {
            let url = `${API_HOST}/api/me`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: jwt,
                },
            });

            if (response.ok) {
                const tmpUser = await response.json();
                setUser(tmpUser);
                localStorage.setItem("role", tmpUser?.roles_id);
                setRole(tmpUser?.roles_id);
            } else {
                // If fetch fails (e.g. 401), we might want to logout or handle it.
                // For now, keeping logic minimal but ensure loading stops.
                if (response.status === 401) {
                    setToken(null);
                    localStorage.removeItem("token");
                }
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            SetInterceptors();
            getUser(token);
        } else {
            setUser({ name: "user", roles_id: 0 });
            setLoading(false);
        }
    }, [token]);

    const value = useMemo(() => ({
        user,
        setUser,
        token,
        setToken,
        role,
        setRole,
        loading,
        isLogged,
        isAdmin,
        isUser,
        isAccountant,
        isSeller
    }), [user, token, role, loading, isLogged, isAdmin, isUser, isAccountant, isSeller]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
